export default class ConsultationFrequency {
  static validFrequencies = [
    "1-week",
    "2-week",
    "1-month",
    "2-month",
    "3-month",
    "4-month",
    "5-month",
    "6-month",
    "1-year",
    "2-year",
    "3-year",
    "5-year"
  ];

  constructor(
    public id: string,
    public enabled: boolean,
    public frequency?: string,
    public comment?: string,
    public type?: string
  ) {}
}
